import React from 'react'
import { PublicPageButton } from 'src/public-pages/shared/components/public-page-button'
import { PublicPageHeading } from 'src/public-pages/shared/components/public-page-heading'
import { PublicPageText } from 'src/public-pages/shared/components/public-page-text'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { CheckCircleIcon } from 'src/shared/icons/check-circle-icon'
import {
  WebsiteButtonsInterface,
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'

export interface ThankYouContentProps {
  homePageUrl?: string
  heading?: WebsiteTypographySettingsStylesInterface
  paragraph?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
  button?: Partial<WebsiteButtonsInterface>
}

export const ThankYouContent = ({
  homePageUrl = '',
  heading,
  paragraph,
  theme,
  button,
}: ThankYouContentProps) => {
  const redirect = () => {
    window.location.href = homePageUrl
  }
  const { t } = useTypedTranslation()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <CheckCircleIcon style={{ marginBottom: '12px' }} />

      <PublicPageHeading
        heading={heading}
        theme={theme}
        style={{ marginBottom: '12px' }}
      >
        {t('website_public_page.thank_you_content.title')}
      </PublicPageHeading>

      <PublicPageText
        paragraph={paragraph}
        theme={theme}
        textAlign="center"
        style={{ marginBottom: '40px' }}
      >
        {t('website_public_page.thank_you_content.sub_title')}
      </PublicPageText>

      <PublicPageButton
        button={button}
        theme={theme}
        text={t('website_public_page.thank_you_content.button_text')}
        onClick={redirect}
        width="100%"
        paragraph={paragraph}
      />
    </div>
  )
}
